import template from './managers_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class ManagersHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class ManagersHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ManagersHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ManagersHelp',
	dialog_class: ManagersHelpPage,
	template: template,
	template_filename: 'translation/dialogs/managers_help',
	provider: 'ps'
};
